import type { CommonTranslations } from "./commonTranslations.types"

const commonFrTranslations: CommonTranslations = {
  "validate": "Valider",
  "send": "Envoyer",
  "understand": "J'ai compris",
  "ok": "OK",
  "reload": "Recharger la page",
  "packageTransferIncluded": "Avec tous nos forfaits, le transfert de votre point d'arrivée à votre station est inclus",
  "confirmation": {
    "confirmationErrorPopupPhone": "04 79 96 30 69",
    "confirmationStatusReservationTitle": "Félicitations !",
    "confirmationStatusReservationSubtitle1": "Votre séjour commence dans",
    "confirmationStatusReservationSubtitle2": "jours.",
    "confirmationReservation1": "Vous allez recevoir d’ici quelques minutes la confirmation de votre séjour et celle de votre paiement.",
    "confirmationReservation2": "Pour rappel, nous procédons ce jour au débit de",
    "confirmationReservation3": "correspondant à",
    "confirmationReservation4": " % du montant de votre séjour.",
    "confirmationReservation5": "Le solde de votre commande, soit",
    "confirmationReservation6": ", sera prélevé automatiquement",
    "confirmationReservation7": ".",
    "confirmationReservation8": "Retrouvez toutes ces informations sur votre compte Travelski. Vous pouvez vous connecter",
    "confirmationReservation9": "ici",
    "confirmationReservation10": ".",
    "confirmationByPhone": "Appeller un conseiller",
    "confirmationBooking100Percent1": "Vous allez recevoir d’ici quelques minutes la confirmation de votre séjour et celle de votre règlement.",
    "confirmationBooking100Percent2": "Pour rappel, nous procédons ce jour au débit de",
    "confirmationBooking100Percent3": ", correspondant à 100% du montant de votre séjour.",
    "confirmationBooking100Percent4": "Retrouvez toutes ces informations sur votre compte Travelski. Vous pouvez vous connecter",
    "confirmationBooking100Percent5": "ici",
    "confirmationBooking100Percent6": ".",
    "confirmationStatusReservationTitleAlreadyPaid": "Vous avez déjà payé votre séjour.",
    "confirmationStatusQuoteTitle": "Votre recherche est sauvegardée",
    "confirmationStatusQuoteSubtitle": "Pensez à finaliser votre réservation.",
    "confirmationQuote1": "Travelski vous remercie de votre confiance et a le plaisir de vous confirmer que votre recherche est sauvegardée.",
    "confirmationQuote2": "Référence :",
    "widgetCartSuccessTitle": "Votre commande train a été enregistrée",
    "widgetSuccessTitle": "Réservation finalisée !",
    "widgetSuccessTicketsEmail": "Merci de votre achat. Vous allez recevoir d'ici quelques minutes vos billets à l'adresse mail :",
    "widgetCartSuccessInfo": "Votre commande a été enregistrée. Vous recevrez vos billets à l'adresse mail :",
    "widgetSuccessBackToSite": "Retourner au site",
    "confirmationQuote3": "Une recherche sauvegardée n’est pas une réservation. Seul le versement d’un acompte ou le paiement intégral du montant du dossier vous assure de la disponibilité de votre séjour.",
    "confirmationReserveQuick": "Réservez vite !",
    "confirmationStatusErrorTitle": "Une erreur est survenue",
    "confirmationError1": "Nous sommes désolé, votre réservation n’a malheureusement pas pu être prise en compte. Nous vous invitons à réessayer ou à nous contactez au",
    "confirmationOtherPaymentMethod": "04 79 96 30 69",
    "confirmationError1Sentence": "La réservation de votre séjour n’a malheureusement pas pu être prise en compte.",
    "confirmationUnavailableText": "Le séjour souhaité n`est malheureusement plus disponible. Veuillez réessayer ou contactez-nous au",
    "confirmationErrorText": "Désolé mais votre paiement vient d’être refusé. Veuillez réessayer ou contactez-nous au",
    "confirmationErrorPhone": "04 79 96 30 69",
    "confirmationErrorPhoneYoonly": "+32 2 808 25 70",
    "confirmationMakeReservationAccountTitle": "Sur votre compte client :",
    "confirmationMakeReservationAccount": "Connectez-vous à la rubrique “Mon compte” pour retrouver votre recherche et bien plus encore",
    "confirmationMakeReservationAccountButton": "Accéder à mon compte",
    "confirmationMakeReservationPhoneTitle": "Par téléphone :",
    "confirmationMakeReservationPhone1": "Appelez l’un de nos conseillers vacances au",
    "confirmationMakeReservationPhone2": "04 79 96 30 69",
    "confirmationStatusUnavailableTitle": "Ce logement n’est plus disponible",
    "confirmationStatusUnavailableSubtitle": "Nous sommes désolés, le séjour que vous avez sélectionné n’est plus disponible.",
    "confirmationUnavailable1": "Le séjour que vous avez sélectionné n’est plus disponible car il vient d’être réservé par un autre internaute.",
    "confirmationUnavailable2": "Vous n’avez pas été débité.",
    "confirmationFindAnother": "Trouvez un autre séjour",
    "confirmationFindAnotherSameTitle": "Garder le même hébergement",
    "confirmationFindAnotherSame1": "C’est votre logement coup de cœur et vous êtes flexible ? Modifier les dates de séjour ou sélectionner une autre chambre.",
    "confirmationFindAnotherSameButton": "Retourner sur la page du séjour",
    "confirmationFindAnotherOtherTitle": "Rester dans la même station",
    "confirmationFindAnotherOther1": "Cette station est plébiscitée, mais nous sommes persuadés que vous pouvez trouver votre bonheur !",
    "confirmationFindAnotherOtherButton": "Nos autres séjours sur",
    "confirmationFindAnotherSearchTitle": "Faire une nouvelle recherche",
    "confirmationFindAnotherSearch1": "Malgré tous nos efforts, vous ne souhaitez pas poursuivre votre recherche sur cette station ?",
    "confirmationFindAnotherSearch2": "Aucun soucis, Travelski propose des séjours dans 160 stations !",
    "confirmationFindAnotherSearchButton": "Faire une nouvelle recherche",
    "confirmationFindAnotherQuestionTitle": "Une question ? Un problème ?",
    "confirmationFindAnotherQuestion1": "Appelez l’un de nos conseillers vacances au 04 79 96 30 69",
    "confirmationYourOrder": "Votre commande",
    "confirmationSummaryDetailsButton": "Détails de ma commande",
    "confirmationAccessAccount": "Accéder à mon compte"
  },
  "contacts": {

    "logInOrRegister": "vous ou inscrivez-vous pour réserver",
    "loginRegister": "Connexion / Inscription",
    "login": "Connexion",
    "emailNotValid": "Continuer",
    "errorWrongEmail": "L’adresse e-mail saisie est invalide. Veuillez vérifier l’e-mail renseigné et réessayer.",
    "contactsFirstName": "Prénom",
    "contactsLastName": "Nom",
    "contactsEmail": "E-mail",
    "contactsOtherEmail": "Se connecter avec un autre e-mail",
    "contactsPassword1": "Mot de passe",
    "contactsPassword2": "Confirmez votre mot de passe",
    "contactsPasswordFormat": "Votre mot de passe doit",
    "contactsPasswordFormatLenght": "Contenir au minimum 8 caractères",
    "contactsPasswordFormatLowercase": "Contenir au moins 1 minuscule",
    "contactsPasswordFormatUppercase": "Contenir au moins 1 majuscule",
    "contactsPasswordFormatNumber": "Contenir au moins 1 chiffre",
    "contactsPasswordFormatCharacter": "Contenir au moins 1 caractère spécial (# ; @ ; $ ...)",
    "contactsPasswordsDontMatch": "Le mot de passe ne correspond pas",
    "contactsEmailIsNotValid": "L’e-mail n’est pas valide",
    "contactsAddress": "Adresse",
    "contactsCity": "Ville",
    "contactsCountry": "Pays",
    "contactsPostalCode": "Code postal",
    "contactsPhoneNumber": "00 00 00 00 00",
    "contactsSubscribeNewsletter": "Je m’abonne à la Newsletter de Travelski.com et je profite des promotions, ventes flash et avantages fidélité !",
    "contactsAcceptConditions1": "J’ai lu et j’accepte les",
    "contactsAcceptConditions2": "Conditions Générales de Vente",
    "contactsAcceptConditions3": "et je suis informé de l’absence de droit de rétractation.",
    "contactsAcceptConditions4": "",
    "contactsIncorrectCredentials": "Vos identifiants sont incorrects",
    "registerCallCenterModalTitle": "Besoin d’aide ?",
    "registerCallCenterModalMessage": "Notre centre d’appel est disponible aux horaires suivants pour vous aider à finaliser votre réservation.",
    "registerCallCenterModalPhone": "Téléphone",
    "registerCallCenterModalOpeningHours": "Horaires du centre d’appel",
    "registerCallCenterModalCallButton": "Appeler le centre d’appel",
  },
  "continue": {
    "continueWithTheseContacts": "Continuer avec ces informations",
    "continue": "Continuer"
  },
  "user": {
    "title": "Coordonnées",
    "userInfoMandatoryField": "Champ obligatoire",
    "userInfoInvalidPhone": "Format invalide. Le numéro de téléphone doit contenir 10 chiffres et commencer par 0.",
    "userInfoInvalidPhoneLength": "Format invalide. Le numéro de téléphone doit contenir 10 chiffres.",
    "userInfoForgotPassword": "Mot de passe oublié ?",
    "userInfoAlreadyHaveAccount": "Vous avez déjà un compte ?",
    "userInfoEnterEmail": "Cliquez sur Envoyer pour réinitialiser votre mot de passe",
    "userInfoEmailSent": "Un lien pour réinitialiser votre mot de passe a été envoyé à",
    "userInfoNewPassword": "Indiquez votre nouveau mot de passe",
    "userInfoYourInformations": "Vos informations",
    "userInfoEmail": "E-mail",
    "userInfoPhone": "Téléphone",
    "userInfoContactHint": "Vos coordonnées nous servent à vous transmettre les documents de réservation.",
    "userInfoToContactYou": "Vous joindre",
    "userInfoLiheMoreDetails": "Plus de détails",
    "userInfoCreateAccount": "Créez un compte",
    "userInfoIsItFirstTime": "Vous partez avec Travelski pour la 1ère fois ?",
    "newPasswordForgotPassword": "Mot de passe oublié ?",
    "newPasswordCreateNewPassword": "Créez votre nouveau mot de passe",
    "newPassword1": "Nouveau mot de passe",
    "newPassword2": "Confirmer votre mot de passe",
    "invalidToken": "Le token est expiré. Veuillez réessayer.",
    "newPasswordSucces": "Votre mot de passe a été réinitialisé avec succès",
  },
  "sessionExpired": "Votre session est sur le point d`expirer. Veuillez cliquer ici pour continuer.",
  "paymentChanged": "Le montant de votre réservation a été modifié.<br>Vous n'avez pas été débité.<br>Veuillez vérifier votre réservation et entrer vos détails de carte de crédit à nouveau.",
  "flightError": "Une erreur est survenue lors de la réservation. Veuillez réessayer."
}

export default commonFrTranslations;
